import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useMemo } from 'react';
import { get } from 'lodash-es';
export var SortFieldType = /*#__PURE__*/ function(SortFieldType) {
    SortFieldType["String"] = "string";
    SortFieldType["Number"] = "number";
    SortFieldType["Date"] = "date";
    return SortFieldType;
}({});
export var SortDirection = /*#__PURE__*/ function(SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
    return SortDirection;
}({});
const sortByString = (a, b)=>{
    const valueA = a.toLowerCase();
    const valueB = b.toLowerCase();
    if (valueA < valueB) {
        return -1;
    }
    if (valueA > valueB) {
        return 1;
    }
    return 0;
};
const sortByNumberOrDate = (a, b)=>{
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
};
export const filterAndSortData = (param)=>{
    let { data, columnDefs, filter, sort } = param;
    let results = data !== null && data !== void 0 ? data : [];
    Object.entries(filter !== null && filter !== void 0 ? filter : {}).forEach((param)=>{
        let [key, { search }] = param;
        results = results.filter((item)=>{
            const searchValue = search.trim().toLowerCase();
            const data = columnDefs[key];
            let itemValue;
            if (!data) {
                return true;
            }
            if (data.getter === 'value') {
                itemValue = data.getValue(item);
            } else {
                itemValue = get(item, data.path);
            }
            return itemValue === null || itemValue === void 0 ? void 0 : itemValue.toString().toLowerCase().includes(searchValue);
        });
    });
    Object.entries(sort !== null && sort !== void 0 ? sort : {}).forEach((param)=>{
        let [key, { direction }] = param;
        results.sort((a, b)=>{
            const _columnDefs_key = columnDefs[key], { type } = _columnDefs_key, data = _object_without_properties(_columnDefs_key, [
                "type"
            ]);
            let aVal;
            let bVal;
            if (data.getter === 'value') {
                aVal = data.getValue(a);
                bVal = data.getValue(b);
            } else {
                aVal = get(a, data.path);
                bVal = get(b, data.path);
            }
            if (type === "string" && typeof aVal === 'string' && typeof bVal === 'string') {
                return direction === "asc" ? sortByString(aVal, bVal) : sortByString(bVal, aVal);
            } else if ((type === "number" || type === "date") && typeof aVal === 'number' && typeof bVal === 'number' || aVal instanceof Date && bVal instanceof Date) {
                return direction === "asc" ? sortByNumberOrDate(aVal, bVal) : sortByNumberOrDate(bVal, aVal);
            }
            return 0;
        });
    });
    return results;
};
export const useFilterAndSortData = (param)=>{
    let { data, columnDefs, filter, sort } = param;
    const filteredData = useMemo(()=>filterAndSortData({
            data,
            columnDefs,
            filter,
            sort
        }), [
        data,
        columnDefs,
        filter,
        sort
    ]);
    return {
        data: filteredData
    };
};
